import { Pipe, PipeTransform } from "@angular/core";
import { AssetHistoryDocumentStatus } from '@app/_models/enums/assetHistoryDocumentStatus';
import { AssetHistory } from '@app/_models/_DTOs/assetHistory';

@Pipe({
    name: 'documentsNeeded',
    pure: true
})
export class DocumentsNeeded implements PipeTransform {
    transform(value: AssetHistory[], args?: any): any {
        return value.filter(assetHistory => {
            return assetHistory.documentStatus == AssetHistoryDocumentStatus.DocumentNeedsToBeGenerated;
        });
    }
}